import AppModal from '@components/AppModal';
import Text from '@components/Text';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

declare module '@stackflow/config' {
    interface Register {
        GiftCanceledModal: {};
    }
}

const GiftCanceledModal: ActivityComponentType<'GiftCanceledModal'> = () => {
    const { pop } = useFlow();
    const { t } = useTranslation('gift');
    return (
        <AppModal title={t('giftCanceledModal.title')}
            confirm={t('giftCanceledModal.confirm')}
            onConfirm={pop} >
            <Text size='title-lg' align='center'>
                {t('giftCanceledModal.description')}
            </Text>
        </AppModal>
    );
};

export default GiftCanceledModal;
